// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-ResizableContainer-___ResizableRow-module__padding {
  padding: 10px;
}

.app-components-ResizableContainer-___ResizableRow-module__paddingLeftRight {
  padding-left: 10px;
  padding-right: 10px;
}

.app-components-ResizableContainer-___ResizableRow-module__paddingTopBottom {
  padding-top: 10px;
  padding-bottom: 10px;
}

.app-components-ResizableContainer-___ResizableRow-module__row {
  display: flex;
  flex: 1;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
}

.app-components-ResizableContainer-___ResizableRow-module__colGap > .app-components-ResizableContainer-___ResizableRow-module__row:not(:nth-child(1)) {
  margin-top: 10px;
}

.app-components-ResizableContainer-___ResizableRow-module__col {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  position: relative;
}

.app-components-ResizableContainer-___ResizableRow-module__rowGap > .app-components-ResizableContainer-___ResizableRow-module__col:not(:nth-child(1)) {
  margin-left: 10px;
}

.app-components-ResizableContainer-___ResizableRow-module__asWidget {
  border: var(--mainBorder);
  padding: 10px;
  background: #fff;
}

.app-components-ResizableContainer-___ResizableRow-module__draggablePart {
  height: 0px;
  width: 100%;
  cursor: row-resize;
  font-size: 14px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  position: relative;
  z-index: 10;
  top: 0;
  right: 0;
}

.app-components-ResizableContainer-___ResizableRow-module__verticalResizeBar {
  width: 100%;
  transition: all 0.1s;
  height: 1px;
  background-color: var(--colors-greyMedium);
}

.app-components-ResizableContainer-___ResizableRow-module__buttonResizeBar {
  border-radius: 4px;
  border: 1px solid var(--colors-greyMedium);
  position: absolute;
  transition: all 0.1s;
  color: var(--colors-greyMedium);
  padding: 0 7px;
  font-size: 12px;
  background-color: #ffffff;
}

.app-components-ResizableContainer-___ResizableRow-module__draggablePart:hover .app-components-ResizableContainer-___ResizableRow-module__buttonResizeBar {
    border: 1px solid var(--colors-grey);
    color: var(--colors-grey);
  }

.app-components-ResizableContainer-___ResizableRow-module__draggablePart:hover .app-components-ResizableContainer-___ResizableRow-module__verticalResizeBar {
    background-color: var(--colors-grey);
  }

.app-components-ResizableContainer-___ResizableRow-module__resizable {
  padding-right: 18px;
}
`, "",{"version":3,"sources":["webpack://./app/components/ResizableContainer/ResizableRow.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAGE;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;AACA;IACE,oCAAoC;EACtC;;AAGF;EACE,mBAAmB;AACrB","sourcesContent":[".padding {\n  padding: 10px;\n}\n\n.paddingLeftRight {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.paddingTopBottom {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.row {\n  display: flex;\n  flex: 1;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: auto;\n}\n\n.colGap > .row:not(:nth-child(1)) {\n  margin-top: 10px;\n}\n\n.col {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-y: auto;\n  position: relative;\n}\n\n.rowGap > .col:not(:nth-child(1)) {\n  margin-left: 10px;\n}\n\n.asWidget {\n  border: var(--mainBorder);\n  padding: 10px;\n  background: #fff;\n}\n\n.draggablePart {\n  height: 0px;\n  width: 100%;\n  cursor: row-resize;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  position: relative;\n  z-index: 10;\n  top: 0;\n  right: 0;\n}\n\n.verticalResizeBar {\n  width: 100%;\n  transition: all 0.1s;\n  height: 1px;\n  background-color: var(--colors-greyMedium);\n}\n\n.buttonResizeBar {\n  border-radius: 4px;\n  border: 1px solid var(--colors-greyMedium);\n  position: absolute;\n  transition: all 0.1s;\n  color: var(--colors-greyMedium);\n  padding: 0 7px;\n  font-size: 12px;\n  background-color: #ffffff;\n}\n\n.draggablePart:hover {\n  .buttonResizeBar {\n    border: 1px solid var(--colors-grey);\n    color: var(--colors-grey);\n  }\n  .verticalResizeBar {\n    background-color: var(--colors-grey);\n  }\n}\n\n.resizable {\n  padding-right: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"padding": `app-components-ResizableContainer-___ResizableRow-module__padding`,
	"paddingLeftRight": `app-components-ResizableContainer-___ResizableRow-module__paddingLeftRight`,
	"paddingTopBottom": `app-components-ResizableContainer-___ResizableRow-module__paddingTopBottom`,
	"row": `app-components-ResizableContainer-___ResizableRow-module__row`,
	"colGap": `app-components-ResizableContainer-___ResizableRow-module__colGap`,
	"col": `app-components-ResizableContainer-___ResizableRow-module__col`,
	"rowGap": `app-components-ResizableContainer-___ResizableRow-module__rowGap`,
	"asWidget": `app-components-ResizableContainer-___ResizableRow-module__asWidget`,
	"draggablePart": `app-components-ResizableContainer-___ResizableRow-module__draggablePart`,
	"verticalResizeBar": `app-components-ResizableContainer-___ResizableRow-module__verticalResizeBar`,
	"buttonResizeBar": `app-components-ResizableContainer-___ResizableRow-module__buttonResizeBar`,
	"resizable": `app-components-ResizableContainer-___ResizableRow-module__resizable`
};
export default ___CSS_LOADER_EXPORT___;
